import React from "react";
import classnames from "classnames";
import ReactSwitch from "react-switch";
import { uuid } from "uuidv4";
import { toast } from "react-toastify";
import {
    CheckboxIcon,
    EyeIcon,
    PencilIcon,
    TrashIcon,
} from "@aureskonnect/react-ui";
import { useSnapshot } from "valtio";
import { useTranslation } from "react-i18next";
import { mutate } from "swr";
import { Tooltip } from "@mui/material";

import { store as ModeOfInformation } from "../../../../components/VerticalLayout/store";
import { useFetchGlobal } from "../../../../api/hooks";
import store, {
    setFnDelete,
    setNumberActive,
    setNumberArchived,
    setIsDeleteCheckClick,
    setIsActionsClicked,
    setIsEdited,
    setActions,
    setIsLoading,
    setKey,
} from "../store";

import ErrorToast from "@components/Common/ErrorTost";
import TimePastSvgIcon from "@components/Common/SvgIcons/TimePastSvgIcon";
import ConsultSvgIcon from "@components/Common/SvgIcons/ConsultSvgIcon";
import {
    setActivationDeactivationMessageModalOpened,
    setMessage,
    setYesFunction,
} from "@components/Common/ConfirmationActivationDeactivationMessageModal/store";
import { generalConfigStore, setItemsDisable } from "@store";
import {
    ArchiveModeOfInformation,
    ArchiveModeOfInformationFranchise,
    AssociateModeOfInformation,
} from "../helper";
import { ID_SALE_SUPPORT_KIOSK } from "../../../../constants/index";

type CustomIconsType = {
    e: any;
    setShopId: Function;
    setRowData: Function;
    setInformation: Function;
    setIsModalOpened: Function;
    isModalOpened: boolean;
    setDataIsUpdated: Function;
    setIsHistoryModalOpened: Function;
    isHistoryModalOpened: boolean;
    setSelectedRows: Function;
    isModeOfInformationArchived: boolean;
    setIsAddModeOfInformationClicked: Function;
    setLocalFilterActive: Function;
    setIsConsult: Function;
};
export function CustomIcons({
    e,
    setShopId,
    setRowData,
    setInformation,
    setIsModalOpened,
    isModalOpened,
    setDataIsUpdated,
    setIsHistoryModalOpened,
    isHistoryModalOpened,
    setSelectedRows,
    isModeOfInformationArchived,
    setIsAddModeOfInformationClicked,
    setLocalFilterActive,
    setIsConsult,
}: CustomIconsType) {
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();
    const {
        numberActive,
        numberArchived,
        shopsModeInformationData,
        archivedModeInformationFranchise,
        isActionsClicked,
        isEdited,
        modify,
        isLoading,
    } = useSnapshot(store);
    const { franchiseID, oneShop, userID, operatorID, shopID } = useSnapshot(
        ModeOfInformation
    );
    const { itemsDisable } = useSnapshot(generalConfigStore);
    const [modeOfInformationState, setModeOfInformationState] = React.useState<
        boolean
    >(e.selectedRow.state);
    const shopId = oneShop ? shopID : 0;
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const uuidUser = localStorage.getItem("uuidUser");

    let dataAssociate: any[] = [];
    let dataArchive: any[] = [];

    if (!oneShop) {
        dataAssociate = AssociateModeOfInformation(shopsModeInformationData);
        dataArchive = ArchiveModeOfInformation(shopsModeInformationData);
    } else {
        dataArchive = ArchiveModeOfInformationFranchise(
            archivedModeInformationFranchise
        );
    }
    async function handleStateChange() {
        setIsLoading(true);
        let id = e.selectedRow.Id;

        if (
            id !== undefined &&
            e.selectedRow[t("Mode of information")] !== undefined
        ) {
            let dataConfig = [
                {
                    userId: userID,
                    operatorId: operatorID,
                    uuidUser: uuidUser,
                    shopId: [e.selectedRow.shopId],
                    franchiseId: franchiseID,
                    isShop: false,
                    data: {
                        [id]: {
                            designation:
                                e.selectedRow[t("Mode of information")],
                            idMI: e.selectedRow?.idMI,
                            tag: e.selectedRow.tag,
                            supportOfSale: e.selectedRow[t("Sales support")],
                            salesSupportData: [
                                e.selectedRow[t("Sales support")],
                            ],
                            displayName: e.selectedRow[t("Display name")],
                            modeOfSale: e.selectedRow[t("Sales method")],
                            isArchived: false,
                            state: !modeOfInformationState,
                            shopId: e.selectedRow.shopId,
                            stateShop: !modeOfInformationState,
                            advancedDisplayName:
                                e.selectedRow.advancedDisplayName,
                        },
                    },
                },
            ];

            const isStateChange =
                e.selectedRow[t("Sales support")].value ===
                ID_SALE_SUPPORT_KIOSK
                    ? true
                    : false;
            let apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/mode_of_Information`;
            try {
                const response: any = await fetchGlobal(apiUrl, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ dataConfig, isStateChange }),
                    method: "POST",
                });
                mutate(apiUrl, response);
                if (response.error) {
                    throw Error(response.message);
                }
                if (
                    e.selectedRow[t("Sales support")].value ===
                    ID_SALE_SUPPORT_KIOSK
                ) {
                    if (
                        !e.selectedRow.state === false &&
                        itemsDisable.find(
                            (item: any) =>
                                item.id === e.selectedRow.idMI &&
                                item.shopId === e.selectedRow.shopId
                        ) === undefined
                    ) {
                        const item = [
                            ...itemsDisable,
                            {
                                id: e.selectedRow.idMI,
                                state: !e.selectedRow.state,
                                shopId: e.selectedRow.shopId,
                            },
                        ];
                        setItemsDisable(item);
                        localStorage.setItem(
                            "itemsDisable",
                            JSON.stringify(item)
                        );
                    } else if (!e.selectedRow.state === true) {
                        const item = itemsDisable.filter(
                            (item: any) =>
                                !(
                                    item.id === e.selectedRow.idMI &&
                                    item.shopId === e.selectedRow.shopId
                                )
                        );
                        setItemsDisable(item);
                        localStorage.setItem(
                            "itemsDisable",
                            JSON.stringify(item)
                        );
                    }
                }
                toast.success(
                    modeOfInformationState === true
                        ? `${t(
                              "The Mode of information has been successfully deactivated"
                          )}`
                        : `${t(
                              "The Mode of information has been successfully activated"
                          )}`,
                    {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 2000,
                        theme: "colored",
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        icon: (
                            <CheckboxIcon height={25} width={25} fill="white" />
                        ),
                    }
                );
                setKey(uuid());
                setIsLoading(false);
            } catch (error: any) {
                setIsLoading(false);
                toast.error(`${t("There's an error")!}`, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                    theme: "colored",
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            }
        }
    }

    async function activeModeOfInformation() {
        toast.dismiss();
        if (e.selectedRow.Id !== undefined) {
            let dataModeOfInformation = [
                {
                    userId: userID,
                    operatorId: operatorID,
                    uuidUser: uuidUser,
                    shopId: [e.selectedRow.shopId],
                    franchiseId: franchiseID,
                    isShop: false,
                    data: {
                        [e.selectedRow.Id]: {
                            designation:
                                e.selectedRow[t("Mode of information")],
                            idMI: e.selectedRow?.idMI,
                            tag: e.selectedRow.tag,
                            supportOfSale: e.selectedRow[t("Sales support")],
                            salesSupportData: [
                                e.selectedRow[t("Sales support")],
                            ],
                            displayName: e.selectedRow[t("Display name")],
                            modeOfSale: e.selectedRow[t("Sales method")],
                            isArchived: false,
                            state:
                                e.selectedRow.shopId === "0"
                                    ? true
                                    : e.selectedRow.state,
                            shopId: e.selectedRow.shopId,
                            stateShop: true,
                            advancedDisplayName:
                                e.selectedRow.advancedDisplayName,
                        },
                    },
                },
            ];

            const apiUrlAdd = `${process.env.REACT_APP_API_V2_URL}/settings/general/mode_of_Information`;
            const requestOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(dataModeOfInformation),
            };
            try {
                const response: any = await fetchGlobal(
                    apiUrlAdd,
                    requestOptions
                );
                if (response.error) {
                    throw Error("error");
                }

                if (
                    e.selectedRow[t("Sales support")].value ===
                    ID_SALE_SUPPORT_KIOSK
                ) {
                    if (e.selectedRow.shopId !== "0") {
                        if (
                            e.selectedRow.state === false &&
                            itemsDisable.find(
                                (item: any) =>
                                    item.id === e.selectedRow.idMI &&
                                    item.shopId === e.selectedRow.shopId
                            ) === undefined
                        ) {
                            setItemsDisable([
                                ...itemsDisable,
                                {
                                    id: e.selectedRow.idMI,
                                    state: false,
                                    shopId: e.selectedRow.shopId,
                                },
                            ]);
                            localStorage.setItem(
                                "itemsDisable",
                                JSON.stringify([
                                    ...itemsDisable,
                                    {
                                        id: e.selectedRow.idMI,
                                        state: false,
                                        shopId: e.selectedRow.shopId,
                                    },
                                ])
                            );
                        }
                    }
                }
                toast.success(
                    `${t(
                        "Information mode has been successfully unarchived"
                    )!}`,
                    {
                        position: toast.POSITION.TOP_CENTER,
                        theme: "colored",
                        icon: (
                            <CheckboxIcon height={25} width={25} fill="white" />
                        ),
                    }
                );
                setIsLoading(false);
                setKey(uuid());
            } catch (e: any) {
                toast.error(`${t("There's an error")!}`, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                    theme: "colored",
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
                setIsLoading(false);
            }
        }
    }

    async function archiveModeOfInformation() {
        setIsLoading(true);
        toast.dismiss();
        if (e.selectedRow.Id !== undefined) {
            let dataModeOfInformation = [
                {
                    userId: userID,
                    operatorId: operatorID,
                    uuidUser: uuidUser,
                    shopId: [e.selectedRow.shopId],
                    franchiseId: franchiseID,
                    isShop: false,
                    data: {
                        [e.selectedRow.Id]: {
                            designation:
                                e.selectedRow[t("Mode of information")],
                            idMI: e.selectedRow.idMI,
                            tag: e.selectedRow.tag,
                            supportOfSale: e.selectedRow[t("Sales support")],
                            salesSupportData: [
                                e.selectedRow[t("Sales support")],
                            ],
                            displayName: e.selectedRow[t("Display name")],
                            modeOfSale: e.selectedRow[t("Sales method")],
                            isArchived: true,
                            state: false,
                            shopId: e.selectedRow.shopId,
                            stateShop: true,
                            advancedDisplayName:
                                e.selectedRow.advancedDisplayName,
                        },
                    },
                },
            ];

            const apiUrlAdd = `${process.env.REACT_APP_API_V2_URL}/settings/general/mode_of_Information`;
            const requestOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(dataModeOfInformation),
            };
            try {
                const response: any = await fetchGlobal(
                    apiUrlAdd,
                    requestOptions
                );
                if (response.error) {
                    throw Error("error");
                }
                if (
                    e.selectedRow[t("Sales support")].value ===
                    ID_SALE_SUPPORT_KIOSK
                ) {
                    if (
                        e.selectedRow.shopId !== "0" &&
                        itemsDisable.find(
                            (item: any) =>
                                item.id === e.selectedRow.idMI &&
                                item.shopId === e.selectedRow.shopId
                        ) !== undefined
                    ) {
                        const item = itemsDisable.filter(
                            (item: any) =>
                                !(
                                    item.id === e.selectedRow.idMI &&
                                    item.shopId === e.selectedRow.shopId
                                )
                        );

                        setItemsDisable(item);
                        localStorage.setItem(
                            "itemsDisable",
                            JSON.stringify(item)
                        );
                    }
                }
                toast.success(
                    `${t(
                        "The Information mode has been successfully archived"
                    )!}`,
                    {
                        position: toast.POSITION.TOP_CENTER,
                        theme: "colored",
                        icon: (
                            <CheckboxIcon height={25} width={25} fill="white" />
                        ),
                    }
                );
                setIsLoading(false);
                setKey(uuid());
                setNumberActive(numberActive - 1);
                setNumberArchived(numberArchived + 1);
            } catch (e) {
                toast.error(`${t("There's an error")!}`, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                    theme: "colored",
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
                setIsLoading(false);
            }
        }
    }

    async function isModeOfSaleArchived() {
        toast.dismiss();
        let isModeOfSaleArchived = false;
        const url = `${process.env.REACT_APP_API_V2_URL}/settings/general/mode_of_sale_archived?userId=${userID}&shopId=${shopId}&franchiseId=${franchiseID}`;
        try {
            const result: any = await fetchGlobal(url, {
                method: "GET",
                headers: { "Accept-Language": i18nextLng },
            });
            result.data.forEach((elt: any) => {
                if (
                    e.selectedRow[t("Sales method")].some(
                        (element: any) => element.label === elt["Mode of sale"]
                    )
                ) {
                    isModeOfSaleArchived = true;
                }
            });
        } catch (error) {
            toast.error(`${t("There's an error")!}`, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                theme: "colored",
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
        return isModeOfSaleArchived;
    }

    async function isInformationModeConsumed() {
        toast.dismiss();
        let isInformationModeUsed = false;
        const url = `${process.env.REACT_APP_API_V2_URL}/settings/consumedSettingGeneral?shopId=${e.selectedRow.shopId}&franchiseId=${franchiseID}&type=informationModes`;
        try {
            const result: any = await fetchGlobal(url, {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            });
            if (
                result.data.some(
                    (el: any) =>
                        el.id === e.selectedRow.idMI &&
                        e.selectedRow.Sales_support.value ===
                            ID_SALE_SUPPORT_KIOSK
                )
            ) {
                isInformationModeUsed = true;
            }
        } catch (error) {
            toast.error(`${t("There's an error")!}`, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                theme: "colored",
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
        return isInformationModeUsed;
    }

    return (
        <React.Fragment>
            {e.selectedRow?.subRows === undefined ? (
                <div
                    className="d-flex justify-content-around"
                    style={{ zIndex: 100 }}
                >
                    {(modify === false && !isModeOfInformationArchived) ||
                    isModeOfInformationArchived ? (
                        <Tooltip title={t("To consult")}>
                            <div>
                                {" "}
                                <ConsultSvgIcon
                                    className="pointer__clz afa_icn_toConsult"
                                    height={35}
                                    width={35}
                                    style={{
                                        cursor: "pointer",
                                        position: "relative",
                                        bottom: "5px",
                                    }}
                                    fill="black"
                                    onClick={() => {
                                        if (isEdited === true) {
                                            setIsActionsClicked(
                                                !isActionsClicked
                                            );
                                            setActions(() => {
                                                setIsEdited(false);
                                                setIsAddModeOfInformationClicked(
                                                    true
                                                );
                                                setRowData(e.selectedRow);
                                                setShopId(e.selectedRow.shopId);
                                                setInformation(e.selectedRow);
                                                setLocalFilterActive(false);
                                            });
                                        } else {
                                            setIsAddModeOfInformationClicked(
                                                true
                                            );
                                            setRowData(e.selectedRow);
                                            setShopId(e.selectedRow.shopId);
                                            setInformation(e.selectedRow);
                                            setLocalFilterActive(false);
                                        }
                                        setIsConsult(true);
                                    }}
                                />
                            </div>
                        </Tooltip>
                    ) : null}
                    {modify === true ? (
                        <>
                            <Tooltip
                                title={
                                    isModeOfInformationArchived ? "" : t("Edit")
                                }
                            >
                                <div>
                                    <PencilIcon
                                        onClick={() => {
                                            if (isEdited === true) {
                                                setIsActionsClicked(
                                                    !isActionsClicked
                                                );
                                                setActions(() => {
                                                    setIsEdited(false);
                                                    setIsAddModeOfInformationClicked(
                                                        true
                                                    );
                                                    setRowData(e.selectedRow);
                                                    setShopId(
                                                        e.selectedRow.shopId
                                                    );
                                                    setInformation(
                                                        e.selectedRow
                                                    );
                                                    setLocalFilterActive(false);
                                                });
                                            } else {
                                                setIsAddModeOfInformationClicked(
                                                    true
                                                );
                                                setRowData(e.selectedRow);
                                                setShopId(e.selectedRow.shopId);
                                                setInformation(e.selectedRow);
                                                setLocalFilterActive(false);
                                            }
                                        }}
                                        height={25}
                                        width={25}
                                        style={{ cursor: "pointer" }}
                                        className={`${classnames(
                                            "pointer__clz cmn_icn_FRedit",
                                            {
                                                "not-allowed-icon__clz":
                                                    isModeOfInformationArchived ||
                                                    e.selectedRow[
                                                        t("Mode of information")
                                                    ] === undefined ||
                                                    isLoading,
                                            },
                                            oneShop ? "mr-2" : "ml-3"
                                        )}`}
                                    />
                                </div>
                            </Tooltip>
                            {oneShop && (
                                <Tooltip
                                    title={
                                        isModeOfInformationArchived
                                            ? ""
                                            : modeOfInformationState === false
                                            ? t("Activate")
                                            : t("Unactivate")
                                    }
                                >
                                    <div>
                                        <ReactSwitch
                                            uncheckedIcon={false}
                                            checkedIcon={false}
                                            handleDiameter={26}
                                            offColor="#f7b4b8"
                                            offHandleColor="#E30613"
                                            checked={modeOfInformationState}
                                            onChange={async () => {
                                                setIsLoading(true);
                                                if (isEdited === true) {
                                                    setIsActionsClicked(
                                                        !isActionsClicked
                                                    );
                                                    setActions(() => {
                                                        setIsEdited(false);
                                                        setIsAddModeOfInformationClicked(
                                                            false
                                                        );
                                                        setMessage(
                                                            modeOfInformationState
                                                                ? t(
                                                                      "Caution, the Information mode may be used by other modules.\n Would you like to confirm the deactivation of the selected language?"
                                                                  )
                                                                : t(
                                                                      "Would you like to confirm the activation of the selected Information mode?"
                                                                  )
                                                        );
                                                        setYesFunction(() => {
                                                            setModeOfInformationState(
                                                                !modeOfInformationState
                                                            );
                                                            handleStateChange();
                                                        });

                                                        setActivationDeactivationMessageModalOpened(
                                                            true
                                                        );
                                                    });
                                                } else {
                                                    setMessage(
                                                        modeOfInformationState
                                                            ? t(
                                                                  "Caution, the Information mode may be used by other modules.\n Would you like to confirm the deactivation of the selected Information mode?"
                                                              )
                                                            : t(
                                                                  "Would you like to confirm the activation of the selected Information mode?"
                                                              )
                                                    );
                                                    setYesFunction(() => {
                                                        setModeOfInformationState(
                                                            !modeOfInformationState
                                                        );
                                                        handleStateChange();
                                                    });

                                                    setActivationDeactivationMessageModalOpened(
                                                        true
                                                    );
                                                }
                                            }}
                                            onColor="#c2eddd"
                                            onHandleColor="#34C38F"
                                            width={50}
                                            height={20}
                                            className={`${classnames(
                                                " cmn_icn_BTenableDisable pointer__clz",
                                                {
                                                    "not-allowed-icon__clz":
                                                        isModeOfInformationArchived ||
                                                        isLoading ||
                                                        e.selectedRow[
                                                            t(
                                                                "Mode of information"
                                                            )
                                                        ] === undefined,
                                                },
                                                oneShop ? "mr-2" : "ml-3"
                                            )}`}
                                        />
                                    </div>
                                </Tooltip>
                            )}

                            {!isModeOfInformationArchived ? (
                                <Tooltip title={t("Archive")}>
                                    <div>
                                        <TrashIcon
                                            onClick={async () => {
                                                setIsLoading(true);
                                                if (isEdited === true) {
                                                    setIsLoading(false);
                                                    setIsActionsClicked(
                                                        !isActionsClicked
                                                    );
                                                    setActions(async () => {
                                                        setIsEdited(false);
                                                        setIsAddModeOfInformationClicked(
                                                            false
                                                        );
                                                        if (
                                                            dataAssociate.includes(
                                                                e.selectedRow.Id
                                                            )
                                                        ) {
                                                            ErrorToast(
                                                                `${t(
                                                                    "Please note that you cannot archive an item assigned to stores."
                                                                )!}`
                                                            );
                                                        } else {
                                                            let isConsumed = await isInformationModeConsumed();
                                                            if (
                                                                isConsumed ===
                                                                true
                                                            ) {
                                                                ErrorToast(
                                                                    t(
                                                                        "Please note, you cannot archive an element used in a template"
                                                                    )
                                                                );
                                                                setIsLoading(
                                                                    false
                                                                );
                                                            } else {
                                                                setIsDeleteCheckClick(
                                                                    true
                                                                );
                                                                setIsLoading(
                                                                    false
                                                                );
                                                                setFnDelete(
                                                                    async () => {
                                                                        archiveModeOfInformation();
                                                                    }
                                                                );
                                                            }
                                                        }
                                                    });
                                                } else {
                                                    setIsAddModeOfInformationClicked(
                                                        false
                                                    );
                                                    if (
                                                        dataAssociate.includes(
                                                            e.selectedRow.Id
                                                        )
                                                    ) {
                                                        ErrorToast(
                                                            `${t(
                                                                "Please note that you cannot archive an item assigned to stores."
                                                            )!}`
                                                        );
                                                        setIsLoading(false);
                                                    } else {
                                                        let isConsumed = await isInformationModeConsumed();
                                                        if (
                                                            isConsumed === true
                                                        ) {
                                                            ErrorToast(
                                                                t(
                                                                    "Please note, you cannot archive an element used in a template"
                                                                )
                                                            );
                                                            setIsLoading(false);
                                                        } else {
                                                            setIsLoading(false);
                                                            setIsDeleteCheckClick(
                                                                true
                                                            );

                                                            setFnDelete(
                                                                async () => {
                                                                    archiveModeOfInformation();
                                                                }
                                                            );
                                                        }
                                                    }
                                                }
                                            }}
                                            height={25}
                                            width={25}
                                            fill="red"
                                            style={{ cursor: "pointer" }}
                                            className={`${classnames(
                                                "pointer__clz",
                                                {
                                                    cmn_icn_FRarchived: !oneShop,
                                                    cmn_icn_BTarchived: oneShop,
                                                    "not-allowed-icon__clz":
                                                        isLoading ||
                                                        e.selectedRow[
                                                            t(
                                                                "Mode of information"
                                                            )
                                                        ] === undefined,
                                                },

                                                oneShop ? "mr-2" : "ml-3"
                                            )}`}
                                        />
                                    </div>
                                </Tooltip>
                            ) : (
                                <Tooltip title={t("Unarchive")}>
                                    <div>
                                        <EyeIcon
                                            height={25}
                                            width={25}
                                            style={{ cursor: "pointer" }}
                                            onClick={async () => {
                                                setIsLoading(true);
                                                let isArchived = await isModeOfSaleArchived();
                                                if (isArchived === true) {
                                                    ErrorToast(
                                                        `${t(
                                                            "Please note that  the unarchiving process could not be successfully completed. Please check the settings of the store(s) data."
                                                        )!}`
                                                    );
                                                    setIsLoading(false);
                                                } else if (
                                                    dataArchive.includes(
                                                        e.selectedRow.Id
                                                    ) &&
                                                    !oneShop
                                                ) {
                                                    setIsModalOpened(
                                                        !isModalOpened
                                                    );
                                                    setIsLoading(false);
                                                } else {
                                                    activeModeOfInformation();
                                                    setNumberActive(
                                                        numberActive + 1
                                                    );
                                                    setNumberArchived(
                                                        numberArchived - 1
                                                    );
                                                }
                                                setInformation(e.selectedRow);
                                                setSelectedRows([
                                                    e.selectedRow,
                                                ]);
                                                setIsLoading(false);
                                            }}
                                            className={`${classnames(
                                                "pointer__clz cmn_icn_FRunarchive",
                                                {
                                                    "not-allowed-icon__clz":
                                                        (dataArchive.includes(
                                                            e.selectedRow.Id
                                                        ) &&
                                                            oneShop) ||
                                                        e.selectedRow[
                                                            t(
                                                                "Mode of information"
                                                            )
                                                        ] === undefined ||
                                                        isLoading,
                                                },
                                                oneShop ? "mr-2" : "ml-3"
                                            )}`}
                                        />
                                    </div>
                                </Tooltip>
                            )}
                        </>
                    ) : null}
                    <Tooltip title={t("Consult history")}>
                        <div>
                            <TimePastSvgIcon
                                onClick={() => {
                                    if (isEdited === true) {
                                        setIsActionsClicked(!isActionsClicked);
                                        setActions(() => {
                                            setIsEdited(false);
                                            setIsAddModeOfInformationClicked(
                                                false
                                            );
                                            setIsHistoryModalOpened(
                                                !isHistoryModalOpened
                                            );
                                            setRowData(e.selectedRow);
                                            setSelectedRows([e.selectedRow]);
                                            setIsLoading(false);
                                        });
                                    } else {
                                        setIsAddModeOfInformationClicked(false);
                                        setIsHistoryModalOpened(
                                            !isHistoryModalOpened
                                        );
                                        setRowData(e.selectedRow);
                                        setSelectedRows([e.selectedRow]);
                                        setIsLoading(false);
                                    }
                                }}
                                className={`${classnames(
                                    "pointer__clz cmn_icn_FRhistory",
                                    oneShop ? "mr-2" : "ml-3",
                                    {
                                        "not-allowed-icon__clz":
                                            e.selectedRow[
                                                t("Mode of information")
                                            ] === undefined || isLoading,
                                    }
                                )}`}
                            />
                        </div>
                    </Tooltip>
                </div>
            ) : null}
        </React.Fragment>
    );
}
